import React, { Component } from 'react';
import Header from '../Header';
import AnalyticsHeader from '../../components/Wholesaler/AnalyticsHeader_API';
import Sidebar from '../Sidebar';
import moment, { relativeTimeRounding } from 'moment';
import filterIcon from '../css/dark/img/filter.svg';
import 'bootstrap-daterangepicker/daterangepicker.css';
import $ from 'jquery';
import List from '../List';
//import FilterTagCom from '../FilterTag';
import FilterTag_API from '../FilterTag_API';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import ColorJson from '../../../src/whitelabel.json';
import Heatmap from '../Heatmap';
import Bar_List from '../BarList';
import Column_Pie from '../Column_Pie';

class PublicAPI extends Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 7);
        var enddate = new Date();
        if (localStorage.getItem('User_Start_Date_API') != "" && localStorage.getItem('User_Start_Date_API') != null && localStorage.getItem('User_Start_Date_API') != undefined) {
            startdate = localStorage.getItem('User_Start_Date_API');
        }
        if (localStorage.getItem('User_End_Date_API') != "" && localStorage.getItem('User_End_Date_API') != null && localStorage.getItem('User_End_Date_API') != undefined) {
            enddate = localStorage.getItem('User_End_Date_API');
        }
        let filterdatalocal = localStorage.getItem('Advance_Filter_API');
        if (filterdatalocal == null || filterdatalocal == '' || filterdatalocal == undefined || filterdatalocal == "null") {
            filterdatalocal = '';
        }
        var _roletype = '', _rolename = '';
        var _wh_Id = 0;
        try {
            var userdata = JSON.parse(localStorage.getItem('user'));
            _roletype = userdata.userrole;
            _rolename = userdata.paramsname;
            _wh_Id = userdata.wholesaler_Id;
        }
        catch (error) { }
        try {
            this.state = {
                WidgetList: [],
                startDate: startdate,
                endDate: enddate,
                AnalyticData: [],
                userdata: JSON.parse(localStorage.getItem('user')),
                scrollArray: {},
                graphData: [],
                AnalyticList: [],
                FilterTagMatch: [],
                FilterTagList: filterdatalocal,
                roletype: _roletype,
                rolename: _rolename,
                wh_Id: _wh_Id
            };
        }
        catch (error) { }
        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time_API', newDate);
        this.handleCalendar = this.handleCalendar.bind(this);
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css('width', 'auto');
            $(".sidebar-submenu").css('width', '100%');
            $(".sidebar-submenu").css('height', 'auto');
            $(".down-arrow").css('display', 'block');
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $("#chartjs-tooltip").hide();
                $(".collapseButton").removeClass('active');
            });
            $(".anylytics.pharmacy").animate({
                marginLeft: 13 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css('width', '0px');
                $(".sidebar-submenu").css('width', '0px');
                $(".sidebar-submenu").css('height', '0px');
                $(".down-arrow").css('display', 'none');
                $('.sidebar-submenu').hide();
                $('body').toggleClass('sub-menu-active');
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active')
            });
            $(".anylytics.pharmacy").animate({
                marginLeft: -170 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    componentDidMount() {
        this.changeData();
        try {
            if (userService.Check_LoggedIn_Status() != 'Login') {
                this.changeData();
                $('body').addClass('analyticPage');
                $('.sidebar-submenu').show();
                $(".analytics-menu").click(e => {
                    if ($('.collapseButton').hasClass("active")) {
                        this.handleCollapse();
                        $('.sidebar-submenu').show();
                        $('body').toggleClass('sub-menu-active');
                    }
                });
            }
        } catch (error) { }
    }
    componentWillUnmount() {
        $('body').removeClass('analyticPage');
    }
    handleCalendar(e, picker) {
        let changedStartDate = new moment(picker.startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(picker.endDate).format("MM/DD/YYYY");
        localStorage.setItem('User_Start_Date_API', changedStartDate);
        localStorage.setItem('User_End_Date_API', changedEndDate);
        this.changeData(true, changedStartDate, changedEndDate);
        try {
            $('.first-one .form-control').val(changedStartDate);
            $('.second-one .form-control').val(changedEndDate);
        }
        catch (error) {
        }
    }
    handleChange = (e) => {
        this.setState({
            ...this.state,
            dashboardName: e
        })
    }
    handleChangeStartEnd = (d) => {
        try {
            this.setState({
                ...this.state,
                startDate: d.split('-')[0],
                endDate: d.split('-')[1]
            });
            this.changeData('', d.split('-')[0], d.split('-')[1]);
        }
        catch (error) {
        }
    }
    changeData(dateChanged, stdate, endate) {
        var APIBaseURL = '/api/publicAPI';
        var wname = "admin"
        var wname = '';
        var startDateObj = '';
        var endDateObj = '';
        if (dateChanged == undefined) {
            if (localStorage.getItem('User_Start_Date_API') != "" && localStorage.getItem('User_Start_Date_API') != null && localStorage.getItem('User_Start_Date_API') != undefined) {
                startDateObj = localStorage.getItem('User_Start_Date_API');
            }
            else {
                var startdate = new Date();
                startDateObj = startdate.setDate(startdate.getDate() - 7);// this.state.startDate;
                endDateObj = this.state.endDate;
            }
            if (localStorage.getItem('User_End_Date_API') != "" && localStorage.getItem('User_End_Date_API') != null && localStorage.getItem('User_End_Date_API') != undefined) {
                endDateObj = localStorage.getItem('User_End_Date_API');
            }
            else {
                var startdate = new Date();
                startDateObj = startdate.setDate(startdate.getDate() - 7);// this.state.startDate;
                endDateObj = this.state.endDate;
            }
        }
        else {
            startDateObj = stdate;
            endDateObj = endate;
        }

        var AdFilterJson = '';
        try {
            AdFilterJson = JSON.parse(localStorage.getItem('Advance_Filter_API'))
            if (AdFilterJson != null && AdFilterJson != '' && AdFilterJson != undefined && AdFilterJson != "null") {
                this.setState({ FilterTagList: JSON.stringify(AdFilterJson) });
            }
            else {
                this.setState({ FilterTagList: '' });
            }
        }
        catch (error) {
            this.setState({ FilterTagList: '' });
        }
        var startDate = new moment(startDateObj).format("YYYYMMDD");
        var endDate = new moment(endDateObj).format("YYYYMMDD");
        let changedStartDate = new moment(startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(endDate).format("MM/DD/YYYY");
        this.setState({ startDate: changedStartDate, endDate: changedEndDate });
        var Request_user = "admin";
        var date_wise_total_public_api_call_RequestJson = "{\"wname\"" + ":\"" + Request_user + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 90 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time_API') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type_API') + "\"}";
        var whname_wise_total_public_api_call_RequestJson = "{\"wname\"" + ":\"" + Request_user + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 90 + ",\"chart_type\"" + ":\"" + "pielist\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time_API') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type_API') + "\"}";
        var endpoint_wise_total_public_api_call_RequestJson = "{\"wname\"" + ":\"" + Request_user + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 90 + ",\"chart_type\"" + ":\"" + "pielist\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time_API') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type_API') + "\"}";
        var api_response_wise_total_public_api_call_RequestJson = "{\"wname\"" + ":\"" + Request_user + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 90 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time_API') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type_API') + "\"}";
        var Table_topndc_public_api_call_RequestJson = "{\"wname\"" + ":\"" + Request_user + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time_API') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type_API') + "\"}";
        var primaryColor;
        var secondaryColor;
        var extraColor;
        if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            primaryColor = ColorJson.ApplicationColor.Rxhacker_primary_color;
            secondaryColor = ColorJson.ApplicationColor.Rxhacker_secondary_color;
            extraColor = ColorJson.ApplicationColor.Rxhacker_extra_color;
        } else {
            primaryColor = ColorJson.ApplicationColor.Glic_primary_color;
            secondaryColor = ColorJson.ApplicationColor.Glic_secondary_color;
            extraColor = ColorJson.ApplicationColor.Glic_extra_color;
        }
        this.setState({
            dashboardName: wname,
            graphData: [
                {
                    url: APIBaseURL + "/Total_API_Call",
                    type: "Bar_List",
                    title: "API Calls",
                    Subtitle: "Total number of API calls received",
                    ColorCode: secondaryColor,
                    XlabelString: "Date",
                    YlabelString: "# of Calls",
                    id: "date_wise_total_public_api_call",
                    RequestJson: date_wise_total_public_api_call_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    url: APIBaseURL + "/WH_API_Call",
                    type: "Column_Pie",
                    title: "API Calls by Wholesaler",
                    Subtitle: "Number of calls for each wholesaler",
                    ColorCode: extraColor,
                    XlabelString: "# of calls",
                    YlabelString: "",
                    DataType: "WholesalerName",
                    id: "wholesaler_wise_total_public_api_call",
                    RequestJson: whname_wise_total_public_api_call_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    url: APIBaseURL + "/Endpoint_API_Call",
                    type: "Column_Pie",
                    title: "API Calls by Endpoint",
                    Subtitle: "Number of calls for each wholesaler",
                    ColorCode: extraColor,
                    XlabelString: "# of calls",
                    YlabelString: "",
                    DataType: "EndpointName",
                    id: "endpoint_wise_total_public_api_call",
                    RequestJson: endpoint_wise_total_public_api_call_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    url: APIBaseURL + "/ResponseTime_API_Call",
                    type: "Bar_List",
                    title: "API Call Response Times",
                    Subtitle: "Average response time for each endpoint",
                    ColorCode: secondaryColor,
                    XlabelString: "# API name",
                    YlabelString: "Response Time (ms)",
                    id: "response_time_wise_total_public_api_call",
                    RequestJson: api_response_wise_total_public_api_call_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    url: APIBaseURL + "/Top50NDC_API_Call",
                    type: "List",
                    title: "Top NDC's Searched",
                    Subtitle: "Top 50 NDC's searched",
                    ColorCode: extraColor,
                    XlabelString: "",
                    YlabelString: "",
                    id: "top_NDC_searched",
                    RequestJson: Table_topndc_public_api_call_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    url: APIBaseURL + "/TimeOfDay_API_Call",
                    type: "Heatmap",
                    title: "API Calls by Time of Day",
                    Subtitle: "Distribution of API calls throughout the day",
                    ColorCode: "#ffba10",
                    DataType: "Hourly request",
                    id: "heatmap11",
                    RequestJson: date_wise_total_public_api_call_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                }
            ]
        });
    }
    handeChangefilter = (e) => {
        try {
            this.setState({
                ...this.state,
                userdata: JSON.parse(localStorage.getItem('user'))
            });
            var APIBaseURL = "";
            var startDateObj = $('.first-one .form-control').val();
            var startDate = new moment(startDateObj).format("YYYYMMDD");
            var endDateObj = $('.second-one .form-control').val();
            var endDate = new moment(endDateObj).format("YYYYMMDD");
            var IsCall = false;
            try {
                if ((localStorage.getItem('Prev_Filter_Status_API').toLowerCase() != localStorage.getItem('Updated_Filter_Status_API').toLowerCase()) || (localStorage.getItem('Prev_AdFilter_Status_API') != localStorage.getItem('Updated_AdFilter_Status_API')) || (localStorage.getItem('Updated_HD_Type_API') != localStorage.getItem('Prev_HD_Type_API'))) {
                    IsCall = true;
                }
                else {
                    IsCall = false;
                }
            }
            catch (error) {
                IsCall = false;
            }
            try {
                if (endDate != this.state.endDate || startDate != this.state.startDate || IsCall == true) {
                    if (IsCall == true) {
                        localStorage.setItem('Prev_Filter_Status_API', localStorage.getItem('Updated_Filter_Status_API'));
                        if (localStorage.getItem('Updated_AdFilter_Status_API') == "null" || localStorage.getItem('Updated_AdFilter_Status_API') == null) {
                            localStorage.setItem('Prev_AdFilter_Status_API', null);
                            localStorage.setItem('Updated_AdFilter_Status_API', null);
                        }
                        else {
                            localStorage.setItem('Prev_AdFilter_Status_API', localStorage.getItem('Updated_AdFilter_Status_API'));
                        }
                        if (localStorage.getItem('Updated_HD_Type_API') == "null" || localStorage.getItem('Updated_HD_Type_API') == null) {
                            localStorage.setItem('Prev_HD_Type_API', null);
                            localStorage.setItem('Updated_HD_Type_API', null);
                        }
                        else {
                            localStorage.setItem('Prev_HD_Type_API', localStorage.getItem('Updated_HD_Type_API'));
                        }
                    }
                    this.changeData('', startDate, endDate);
                }
            } catch (error) {
            }
        } catch (error) { }
    }
    render() {
        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'distributor') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'subadmin') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'wholesaler') {
                return <Redirect to='/pageNotFound' />
            }
        } catch (error) { }
        return (
            <div className="anylytics pharmacy">
                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                <Header />
                <h2 className="dashboardHeading">Public API Analytics<span className="beta-link"><span className="beta">Beta</span></span></h2>
                <AnalyticsHeader handleChange={this.handeChange} handleChangeDateNew={this.handleChangeStartEnd} handeChangefilter={this.handeChangefilter} startDate={this.state.startDate} endDate={this.state.endDate} />
                <Sidebar AnalyticList={this.props.AnalyticData} />
                <div className="dashboard-content-parent">
                    <div className="newBoard">
                        <div className="parent">
                            <div className="contentContainer">
                                <div>
                                    <div className='row'>
                                        <div className='double-column'>
                                            <div className="dashboard-container" id="dashboard-container">
                                                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                                                <FilterTag_API Rolename={this.state.rolename} wh_Id={this.state.wh_Id} Roletype={this.state.roletype} df={new moment(this.state.startDate).format("YYYYMMDD")} dt={new moment(this.state.endDate).format("YYYYMMDD")} handlechangea={this.handeChangefilter} FilterTags={this.state.FilterTagList} Loading={true} />
                                                {
                                                    this.state.graphData.map((item, index, id) => {
                                                        var k = null;
                                                        return (
                                                            ((this.state.dashboardName.replace(" Dashboard (wholesaler)", "").toLowerCase() == 'patient rx discount' && item.title == 'Transactions by Prescriber')) ? null :
                                                                <div id={item.id + index} className={`${item.type == "Bar" ? "widget ui-draggable ui-resizable" : item.type == "Line" ? "widget ui-draggable ui-resizable second" : "widget ui-draggable ui-resizable customScroll third"}${item.id == "date_wise_total_public_api_call" ? ' full-layout barlist' : ''}${item.id == "response_time_wise_total_public_api_call" ? ' full-layout barlist' : ''}${item.id == "heatmap11" ? ' full-layout barlist' : ''}${item.id == "wholesaler_wise_total_public_api_call" ? ' layout-not-margin barlist' : ''}${item.id == "top_NDC_searched" ? ' layout-not-margin barlist' : ''}${item.id == "endpoint_wise_total_public_api_call" ? ' layout-left-margin barlist' : ''}`} key={"graph-widget" + index}>
                                                                    {/*<div className="widget-head" key={"graph-widget-head" + index}>*/}
                                                                    {/*    <h3>*/}
                                                                    {/*        <a>{item.title}</a>*/}
                                                                    {/*    </h3>*/}
                                                                    {/*    <p>*/}
                                                                    {/*        <a>{item.Subtitle}</a>*/}
                                                                    {/*    </p>*/}
                                                                    {/*</div>*/}
                                                                    <div className="widget-content" key={"graph-widget-content" + index}>
                                                                        <div className="custom-scroll">
                                                                            {
                                                                                <div className="scroll-content" style={{ height: this.state.scrollArray[this.state.graphData[index].id] }}>
                                                                                    {item.type == "Bar_List" ? <Bar_List data={item} key={"barlistgraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                                    {item.type == "List" ? <List data={item} key={"listgraph" + index} _Index={index} handlechangea={this.handeChangefilter} /> : null}
                                                                                    {item.type == "Heatmap" ? <Heatmap data={item} key={"heatmapmatrix" + index} ColorCode={item.ColorCode} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                                    {item.type == "Column_Pie" ? <Column_Pie data={item} key={"columnpiegraph" + index} _Index={index} handlechangea={this.handeChangefilter} /> : null}
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="widget-foot">
                                                                        &nbsp;
                                                                    </div>
                                                                </div>
                                                        )
                                                    })
                                                }
                                                <div className="sortby">
                                                    <a href="javascript:void('0')"><img src={filterIcon} alt="filterIcon" />Calendar</a>
                                                    <a href="javascript:void('0')"><img src={filterIcon} alt="filterIcon" />Filter</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default PublicAPI;